<template>
  <a-card :bordered="false" :bodyStyle="{padding:'20px'}" :headStyle="{borderBottom:'0px',paddingLeft:'20px'}">
    <a-row slot="title">
      <span class="card-title">基本信息</span>
    </a-row>
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :label-col="currentFormLayout.labelCol"
      :wrapper-col="currentFormLayout.wrapperCol">
      <a-form-model-item label="网站地址">
        <span>{{ siteUrl }}</span>
        <a style="margin-left: 20px;" @click="onCopy">复制</a>
      </a-form-model-item>
      <a-form-model-item label="网站logo" prop="siteLogo">
        <div style="display: flex;">
          <a-upload
            :action="uploadFileUrl"
            :multiple="false"
            :showUploadList="false"
            listType="picture-card"
            @change="fileInfo=>onUploadChange(fileInfo,1)"
            :before-upload="handleBefore"
          >
            <img v-if="ruleForm.siteLogo" :src="ruleForm.siteLogo" alt="avatar" class="selected-image"/>
            <div v-else>
              <a-icon type="plus"/>
            </div>
          </a-upload>
          <span style="color:#999;margin-top: 70px;">建议尺寸116px*40px，格式.jpg、.png、.jpeg</span>
        </div>
      </a-form-model-item>
      <a-form-model-item label="网站主题">
        <a-select v-model="ruleForm.siteSubject" style="max-width:500px" placeholder="请选择">
          <a-select-option :value="0">
            默认主题
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="网站配色">
        <div class="color-list">
          <div
            class="color-box"
            :class="item.value === ruleForm.siteColor?'selected-box':''"
            v-for="(item,index) in colorList"
            :key="index"
            :style="{background: item.key}"
            @click="onChangeColor(item.value)"
          ></div>
        </div>
      </a-form-model-item>
      <a-form-model-item label="域名绑定" prop="siteBind">
        <!--  @change="onTextChange"-->
        <a-input v-model="ruleForm.siteBind" placeholder="不需要加http://前缀" :maxLength="400"
                 style="max-width:500px"/>
        <div style="max-width:500px;line-height: 20px;color: #999">请在域名解析平台添加该域名A记录，IP绑定192.168.1.1
        </div>
        <div style="max-width:500px;line-height: 20px;color: #999">
          域名需在工信部完成备案，且备案主体与当前后台认证主体一致
        </div>
      </a-form-model-item>
      <a-form-model-item label="意见反馈链接">
        <a-input v-model="ruleForm.suggest" placeholder="请输入" :maxLength="400" style="max-width:500px"/>
      </a-form-model-item>
      <a-form-model-item label="域名SSL证书">
        <a-upload
          :action="uploadFileUrl"
          :multiple="false"
          :file-list="fileList"
          @change="handleChangeFile"
          :beforeUpload="beforeUploadFile"
          :remove="handleRemove"
        >
          <a-button>
            <a-icon type="upload"/>
            上传文件
          </a-button>
          <span style="color: #999;">请上传证书压缩包支持.zip、.rar格式</span>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="域名备案号">
        <a-input v-model="ruleForm.siteNumber" :maxLength="255" placeholder="如粤ICP备16010228号-1"
                 style="max-width:500px"/>
      </a-form-model-item>
      <a-form-model-item label="ICP经营许可证">
        <a-input v-model="ruleForm.manageLicence" :maxLength="225" placeholder="如粤ICP-B 1010228号"
                 style="max-width:500px"/>
      </a-form-model-item>
      <a-form-model-item label="营业执照">
        <div style="display: flex;">
          <a-upload
            :action="uploadFileUrl"
            :multiple="false"
            :showUploadList="false"
            listType="picture-card"
            @change="fileInfo=>onUploadChange(fileInfo,2)"
            :before-upload="handleBefore"
          >
            <img v-if="ruleForm.businessLicense" :src="ruleForm.businessLicense" alt="avatar" class="selected-image"/>
            <div v-else>
              <a-icon type="plus"/>
            </div>
          </a-upload>
          <span style="color:#999;margin-top: 70px;">支持.jpg、.png、.jpeg格式</span>
        </div>
      </a-form-model-item>
      <a-form-model-item label="旅行社执照">
        <div style="display: flex;">
          <a-upload
            :action="uploadFileUrl"
            :multiple="false"
            :showUploadList="false"
            listType="picture-card"
            @change="fileInfo=>onUploadChange(fileInfo,3)"
            :before-upload="handleBefore"
          >
            <img v-if="ruleForm.travelAgency" :src="ruleForm.travelAgency" alt="avatar" class="selected-image"/>
            <div v-else>
              <a-icon type="plus"/>
            </div>
          </a-upload>
          <span style="color:#999;margin-top: 70px;">支持.jpg、.png、.jpeg格式</span>
        </div>
      </a-form-model-item>
      <a-form-model-item label="底部其他信息">
        <a-textarea v-model="ruleForm.bottomInfo" placeholder="@2021  XXX.com  版权所有  |  法律顾问：深圳某某律师事务所 王某某  |  服务投诉及紧急事件联系电话：123-456-789转1

公司地址：广东省深圳市XXX  ，投诉及建议邮箱：XXX@126.com" :rows="6" :maxLength="300" style="max-width:500px"/>
      </a-form-model-item>
      <a-form-model-item label="商家服务热线">
        <a-textarea v-model="ruleForm.merchantHotLine" placeholder="酒店门票商家：0755-123456
线路跟团商家：0755-123456" :rows="6" style="max-width:500px" :maxLength="300"/>
      </a-form-model-item>
      <a-form-model-item label="消费者服务热线">
        <a-textarea v-model="ruleForm.consumerHotLine" placeholder="酒店门票消费者：0755-123456
线路跟团消费者：0755-123456" :rows="6" style="max-width:500px" :maxLength="300"/>
      </a-form-model-item>
      <a-form-model-item label="统计代码">
        <a-textarea v-model="ruleForm.statistics" placeholder="请输入" :rows="6" style="max-width:500px"
                    :maxLength="1000"/>
      </a-form-model-item>

      <a-form-model-item
        :label="index === 0 ?'在线客服':''"
        v-for="(item, index) in phoneList"
        :key="index"
        :wrapper-col="index === 0?{}:currentFormLayout.offsetCol">
        <a-input
          placeholder="请输入QQ号码"
          v-model="phoneList[index]"
          style="max-width:400px; margin-right: 8px"
        />
        <a-icon
          v-if="phoneList.length > 1"
          :disabled="phoneList.length === 1"
          type="minus-circle-o"
          @click="removePhone(item)"
        />
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
        <a-button type="dashed" style="width: 400px;" @click="addPhone">
          <a-icon type="plus"/>
          添加
        </a-button>
      </a-form-model-item>
      <a-form-model-item label="管理人手机号" required>
        <a-input :value="getShowMobile(managePhone)" disabled style="max-width:400px;"/>
      </a-form-model-item>
      <a-form-model-item label="验证码" prop="verifyCode">
        <a-input placeholder="请输入验证码" v-model="ruleForm.verifyCode" style="max-width:280px;"/>
        <a-button v-if="!isShow" style="margin-left:20px;" :disabled="isGetCode" @click="onEventCode">获取验证码
        </a-button>
        <a-button v-else style="margin-left:20px;"> ({{ countDown }}s)后重新获取</a-button>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
        <a-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</a-button>
        <a-button style="margin-left: 20px;" @click="goReset">重置</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'

export default {
  name: 'BasicInformation',
  mixins: [ruleFormMixins],
  data() {
    return {
      isShow: false,
      timer: null,
      isGetCode: false,
      countDown: '',
      ruleForm: {
        suggest: '',
        siteLogo: '',
        siteSubject: 0,
        siteColor: 'theme-green',
        siteSsl: '',
        verifyCode: '',
        siteBind: '',
        siteNumber: '',
        manageLicence: '',
        businessLicense: '',
        travelAgency: '',
        bottomInfo: '',
        merchantHotLine: '',
        consumerHotLine: ''
      },
      phoneList: [''],
      managePhone: this.$store.getters.userInfo.mobile,
      rules: {
        siteBind: [
          {
            pattern: /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/,
            message: '请输入正确的域名',
            trigger: 'blur'
          }
        ],
        modularDetailTitle: [{ required: true, message: '请输入', trigger: 'change' }],
        siteLogo: [{ required: true, message: '请上传网站logo', trigger: 'change' }],
        verifyCode: [{ required: true, message: '请输入验证码', trigger: 'change' }]
      },
      submitLoading: false,
      fileList: [],
      imageUrl: '',
      uploadFileUrl: '',
      colorList: [],
      siteUrl: '',
      copyText: ''
    }
  },
  mounted() {
    let appConfig = this.getAppConfig()
    this.uploadFileUrl = appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    this.getThemeColor()
    this.getDetails()
  },
  methods: {
    getThemeColor() {
      let url = 'pc/v2/basic-data/color'
      this.getHttpServices().getUserService().post(url)
        .then(res => {
          this.colorList = res
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    getDetails() {
      let url = 'pc/v2/basic-data/query'
      this.getHttpServices().getUserService().post(url)
        .then(res => {
          if (res) {
            this.ruleForm = res
            this.ruleForm.consumerHotLine = this.formattingString(this.ruleForm.consumerHotLine)
            this.ruleForm.merchantHotLine = this.formattingString(this.ruleForm.merchantHotLine)
            this.ruleForm.bottomInfo = this.formattingString(this.ruleForm.bottomInfo)
            if (!res.siteBind) {
              this.getSiteUrl()
            } else {
              this.siteUrl = this.ruleForm.siteBind
              this.copyText = this.ruleForm.siteBind
            }
            if (res.siteSsl) {
              this.fileList = [
                {
                  uid: '-1',
                  name: res.siteSsl,
                  status: 'done',
                  url: res.siteSsl
                }
              ]
            }
            this.phoneList = res.onlineService.split(',')
          } else {
            this.getSiteUrl()
          }
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    onTextChange() {
      this.copyText = this.ruleForm.siteBind
    },
    getSiteUrl() {
      let url = 'pc/v2/basic-data/init/' + this.$store.getters.userInfo.merchantId
      this.getHttpServices().getUserService().post(url)
        .then(res => {
          this.siteUrl = res.url
          this.copyText = res.url
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    formattingString(str) {
      str = str.replace('<pre>', '')
      str = str.replace('</pre>', '')
      return str
    },
    goBack() {
      this.$router.go(-1)
    },
    goReset() {
      this.$refs.ruleForm.resetFields()
    },
    onCopy() {
      this.$copyText(this.copyText).then(message => {
        this.$message.success('复制完毕')
      }).catch(err => {
        this.$message.error('复制失败')
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.handleOk()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    handleOk() {
      let parms = {
        ...this.ruleForm
      }
      parms.onlineService = this.phoneList.join(',')
      parms.managerMobile = this.managePhone
      parms.bottomInfo = '<pre>' + this.ruleForm.bottomInfo + '</pre>'
      parms.merchantHotLine = '<pre>' + this.ruleForm.merchantHotLine + '</pre>'
      parms.consumerHotLine = '<pre>' + this.ruleForm.consumerHotLine + '</pre>'
      this.submitLoading = true
      this.getHttpServices().getUserService().post('pc/v2/basic-data/save', parms).then(res => {
        this.$message.success('保存成功')
        this.submitLoading = false
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        this.submitLoading = false
      })
    },
    onUploadChange(file, type) {
      if (file.file.status != 'removed') {
        let fileList = [...file.fileList]
        fileList = fileList.slice(-1)
        fileList.forEach(file => {
          // 因为只有一个，所以可以用
          if (file.response) {
            if (type == 1) {
              this.ruleForm.siteLogo = file.response.data
              console.error('siteLogo', this.ruleForm.siteLogo)
            } else if (type == 2) {
              this.ruleForm.businessLicense = file.response.data
            } else {
              this.ruleForm.travelAgency = file.response.data
            }
          }
        })
      } else {
        this.fileList = []
        if (type == 1) {
          this.ruleForm.siteLogo = ''
        } else if (type == 2) {
          this.ruleForm.businessLicense = ''
        } else {
          this.ruleForm.travelAgency = ''
        }
      }
    },
    onChangeTextarea(e, type) {
      this.getLogUtils().errorWithTag('111', e)
    },
    handleBefore(file) {
      // 限制图片 格式、size、分辨率
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isJPEG || isPNG)) {
        this.$message.error('上传图片的格式不正确，不是JPG、JPEG、PNG')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于2M!')
      }
      return true
    },
    handleChangeFile(info) {
      if (info.file.status && info.file.status != 'removed') {
        let fileList = [...info.fileList]
        fileList = fileList.slice(-1)
        fileList = fileList.map(file => {
          if (file.response) {
            file.url = file.response.data
          }
          return file
        })
        this.fileList = fileList
        if (this.fileList.length > 0) {
          this.ruleForm.siteSsl = this.getUrlFromFileList(this.fileList)
        } else {
          this.ruleForm.siteSsl = ''
        }
      }
    },
    // 附件上传
    // handleChange({fileList}) {
    //   this.getLogUtils().logWithTag('handleChange', fileList)
    //   this.fileList = fileList.slice(-1);
    //   this.fileList = this.fileList.map(file => {
    //     if (file.response) {
    //       file.url = file.response.data;
    //     }
    //     return file;
    //   });
    //   this.getLogUtils().logWithTag('图片上传成功', this.fileList)
    //   if(this.fileList.length>0){
    //     this.ruleForm.sslUrl = this.getUrlFromFileList(this.fileList);
    //   }else{
    //     this.ruleForm.sslUrl = "";
    //   }
    //   this.getLogUtils().logWithTag('sslUrl',this.ruleForm.sslUrl)
    // },
    getUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        if (fileList[0] && fileList[0].response) {
          return fileList[0].response.data
        }
      }
      return ''
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.ruleForm.siteSsl = ''
    },
    beforeUploadFile(file) {
      let extensionsName = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = extensionsName === 'zip' || extensionsName === 'rar'
      if (!extension) {
        this.$message.error('请上传证书压缩包支持.zip、.rar格式')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于2M')
        return false
      }
      return true
    },
    onChangeColor(value) {
      this.ruleForm.siteColor = value
    },
    removePhone(item) {
      let index = this.phoneList.indexOf(item)
      if (index !== -1) {
        this.phoneList.splice(index, 1)
      }
    },
    addPhone() {
      this.phoneList.push('')
    },
    getShowMobile(mobile) {
      if (mobile && mobile.length > 3) {
        return mobile.substr(0, 3) + '****' + mobile.substr(mobile.length - 4)
      }
      return mobile
    },
    onEventCode() {
      this.getHttpServices().getBaseService().post('sms/verification', {
        effect: 8,
        mobile: this.$store.getters.userInfo.mobile,
        userType: 1
      }).then(res => {
        this.getLogUtils().logWithTag('==onEventCode==', res)
        this.getCode()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getCode() {
      let NUM_SECOND = 30
      if (!this.timer) {
        this.countDown = NUM_SECOND
        this.isShow = true
        this.timer = setInterval(() => {
          if (this.countDown > 0 && this.countDown <= NUM_SECOND) {
            this.countDown--
            this.getCode()
          } else {
            this.clearFun()
          }
        }, 1000)
      }
    },
    clearFun() {
      clearInterval(this.timer)
      this.timer = null
      this.countDown = ''
      this.isShow = false
    }
  }
}
</script>

<style lang="less">
.ant-upload-picture-card-wrapper {
  width: 140px;
}

.selected-image {
  width: 116px;
  height: 40px;
}

.color-list {
  display: flex;

  .color-box {
    width: 70px;
    height: 30px;
    border-radius: 5px;
    margin: 5px 20px 5px 0;
  }
}

.selected-box {
  box-sizing: border-box;
  border: 2px solid rgba(0, 0, 0, 0.3);
}
</style>